import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

const slides = [
    {
        title: "Annual Festival (Ulsavam)",
        image: "./images/devi-logo.png",
        content: `The annual festival begins each year on the day of Karthika in the month of Makaram and lasts for seven days. During this time, the Devi's Udaval is kept at the Tali Mahadeva Temple. A few days prior, it is taken to the Valayanad Temple.

The festival features Bharatanatyam, Mohiniyattam, Thiruvathira, Chendamelam (Tayambaka), Ganamela, and Nadakam. Palivetta and Arattu are key rituals. Thottam Pattu is also held in April at Tarakal Kavu.`
    },
    {
        title: "Navarathri Ulsavam",
        image: "./images/devi-logo.png",
        content: `The Navarathri Ulsavam lasts for nine days starting from the first day of Navarathri. It includes cultural performances, dances, and Tayambaka.

Special poojas are conducted daily. A key highlight is Vidyarambam at Vatoli Illam, marking children's initiation into education.`
    },
    {
        title: "Kalamezhuthu Pattu",
        image: "./images/devi-logo.png",
        content: `Kalamezhuthupattu is observed from the 1st of Vrichikam for 41 days during the Mandala season.`
    },
    {
        title: "Chandhattam",
        image: "./images/devi-logo.png",
        content: `Chandhattam is a special pooja event held at Valayanad during the Malayalam month of Karkidakam on a Wednesday.`
    },
    {
        title: "Illam Nira",
        image: "./images/devi-logo.png",
        content: `Illam Nira is conducted on a specific day in the Malayalam month of Karkidakam.`
    },
    {
        title: "Ramayana Parayanam & Sapthaha Yagnam",
        image: "./images/devi-logo.png",
        content: `During Karkidakam, Ramayana Parayanam is conducted throughout the month. Additionally, Sapthaha Yagnam is held once a year in the temple.`
    }
];

export default function Festivals() {
    const [index, setIndex] = useState(0);
    const [direction, setDirection] = useState(0);

    const nextSlide = () => {
        setDirection(1);
        setIndex((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setDirection(-1);
        setIndex((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const variants = {
        enter: (direction) => ({
            x: direction > 0 ? 300 : -300,
            opacity: 0
        }),
        center: {
            x: 0,
            opacity: 1
        },
        exit: (direction) => ({
            x: direction > 0 ? -300 : 300,
            opacity: 0
        })
    };

    return (
        <div className="w-full max-w-6xl mx-auto p-20">
            <div className="relative overflow-hidden rounded-3xl shadow-2xl bg-white" style={{padding:'50px'}}>
                <AnimatePresence custom={direction} mode="wait">
                    <motion.div
                        key={index}
                        custom={direction}
                        variants={variants}
                        initial="enter"
                        animate="center"
                        exit="exit"
                        transition={{ duration: 0.6 }}
                        className="row"
                    >
                        <div className="col-md-4">
                            <img
                                src={slides[index].image}
                                alt={slides[index].title}
                                className="w-full h-80 object-cover rounded-2xl"
                            />
                        </div>
                        <div className="col-md-8" >
                             <div className="col-md-12" style={{margin:'50px'}}>
                            <h2  style={{fontFamily:'anek malayalam'}}>
                                {slides[index].title}
                            </h2>
                            <p  style={{fontFamily:'anek malayalam',fontSize:'15pt'}}>
                                {slides[index].content}
                            </p>
                        </div>
                        </div>

                       
                    </motion.div>
                </AnimatePresence>

                <button
                    onClick={prevSlide}
                    className="btn btn-warning absolute top-1/2 left-4 -translate-y-1/2  shadow-lg rounded-full p-2 hover:scale-110 transition"
                style={{marginRight:'5px'}}>
                    <ChevronLeft />
                </button>

                <button
                    onClick={nextSlide}
                    className="btn btn-warning absolute top-1/2 right-4 -translate-y-1/2  shadow-lg rounded-full p-2 hover:scale-110 transition"
                >
                    <ChevronRight />
                </button>
            </div>
        </div>
    );
}
